import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';
import TitleLabel from '../../Titles/TitleLabel';

const CardImageBasedXLargeStatic = ({
  date: _date,
  franchise,
  header,
  image,
  tags,
  title,
  url,
}) => {
  const headline = header?.headline;
  const date = getFormattedDate(_date);

  return (
    <div
      className="grid grid-cols-12 gap-x-3.75 sm:gap-x-5 lg:gap-x-10"
      data-component-id="card_image_link"
    >
      <div className="relative col-span-12">
        <Link to={url}>
          <GatsbyImage
            alt={title}
            className="h-60 sm:h-[420px] lg:h-[569px] image-hover"
            image={getImage(image)}
          />
        </Link>
      </div>
      <div className="col-span-9">
        <div className="mt-4">
          <TitleLabel franchise={franchise} tags={tags} />
        </div>

        <h1 className="mt-2 stink-h1 text-liquorice">
          <Link className="stink-h1 text-hover" to={url}>
            {title}
          </Link>
        </h1>

        <p className="mt-3 text-slate stink-body-1">{headline}</p>
        {date && <p className="mt-3 stink-footnote text-slate">{date}</p>}
      </div>
    </div>
  );
};

CardImageBasedXLargeStatic.propTypes = {
  date: PropTypes.string,
  franchise: PropTypes.object,
  header: PropTypes.object,
  image: PropTypes.object,
  tags: PropTypes.array,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default CardImageBasedXLargeStatic;
